// 宝箱：プレイヤーが触れて Space で開く（簡易実装：触れた瞬間に開く）
import Phaser from 'phaser';
import { bus } from '../systems/EventBus';

// Tiny Dungeon に「閉じた宝箱／開いた宝箱」のタイル番号があるはず（実機確認で調整）
const CLOSED_FRAME = 89; // 暫定
const OPEN_FRAME = 90; // 暫定

export class Chest extends Phaser.Physics.Arcade.Image {
  public opened = false;
  public itemKey: string;

  constructor(scene: Phaser.Scene, x: number, y: number, itemKey: string) {
    super(scene, x, y, 'dungeon', CLOSED_FRAME);
    scene.add.existing(this);
    scene.physics.add.existing(this);
    (this.body as Phaser.Physics.Arcade.Body).setImmovable(true).setSize(14, 14).setOffset(1, 1);
    this.setScale(2);
    this.itemKey = itemKey;
  }

  open(): void {
    if (this.opened) return;
    this.opened = true;
    this.setFrame(OPEN_FRAME);
    bus.emit('chest-opened', { itemKey: this.itemKey });
  }
}
